/**
 * Image Marquee — the only behavior needed in JS is pausing the animation
 * when it's scrolled off-screen. Everything else (the loop itself, the
 * pause-on-hover, the reduced-motion fallback) is pure CSS.
 */
(function () {
  document.querySelectorAll('[data-marquee]').forEach(function (root) {
    var track = root.querySelector('[data-mq-track]');
    if (!track || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // A class, not an inline style — inline styles always beat external
        // stylesheet rules regardless of specificity, which was silently
        // overriding the CSS hover-pause rule the moment this ran once.
        track.classList.toggle('mq__track--offscreen', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(root);
  });
})();